import { createContext, useContext } from 'react'

export const NonceContext = createContext<string | undefined>(undefined)

export function useNonce(): string | undefined {
  return useContext(NonceContext)
}
